import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../user.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss', '../edit-profile/edit-profile.component.scss'],
  standalone: false
})
export class ChangePasswordComponent {
  private userService = inject(UserService);

  changePwdForm = new FormGroup({
    currentPwd: new FormControl('', [Validators.required]),
    newPwd: new FormControl('', [Validators.required, Validators.minLength(6)]),
    confirmNewPwd: new FormControl('', [Validators.required])
  });

  currPwdError?: string;
  newPwdError?: string;
  confirmNewPwdError?: string;
  isLoading = false;
  successMessage = '';
  errorMessage = '';

  onSubmit() {
    this.errorMessage = '';
    this.successMessage = '';
    this.currPwdError = this.checkCurrPwdError();
    this.newPwdError = this.checkNewPwd();
    this.confirmNewPwdError = this.checkConfirmNewPwd();

    if (!this.currPwdError && !this.newPwdError && !this.confirmNewPwdError) {
      this.isLoading = true;
      this.userService.changePassword(this.currPwd.value, this.newPwd.value).subscribe({
        next: () => {
          this.isLoading = false;
          this.successMessage = 'การเปลี่ยนรหัสผ่านสำเร็จ';
        },
        error: (err) => {
          this.isLoading = false;
          this.errorMessage = err?.error?.message;
        }
      });
    }
  }

  private checkCurrPwdError(): string {
    if (this.currPwd.errors) {
      return 'กรุณาระบุรหัสผ่าน';
    }
  }

  private checkNewPwd(): string {
    if (this.newPwd.errors) {
      return 'รหัสผ่านมีความยาวอย่างน้อย 6 ตัวอักษร';
    }
    if (this.newPwd.value === this.currPwd.value) {
      return 'รหัสผ่านใหม่ต้องแตกต่างจากรหัสผ่านเดิม';
    }
  }

  private checkConfirmNewPwd(): string {
    if (this.confirmNewPwd.errors) {
      return 'กรุณายืนยันรหัสผ่าน';
    }
    if (this.confirmNewPwd.value !== this.newPwd.value) {
      return 'รหัสผ่านไม่ตรงกัน';
    }
  }

  private get currPwd() {
    return this.changePwdForm.get('currentPwd');
  }
  private get newPwd() {
    return this.changePwdForm.get('newPwd');
  }
  private get confirmNewPwd() {
    return this.changePwdForm.get('confirmNewPwd');
  }
}
